const navigation = document.querySelector('.navigation-container');
const navigationList = document.querySelector('.navigation');
const header = document.querySelector('.header');
const navButtons = document.querySelectorAll('.navigation-button');

const navButtonScroll = document.querySelector('.navigation-button--scroll');
const navButtonNoScroll = document.querySelector('.navigation-button--no-scroll');

if (navigation) {

  let options = {
    threshold: 0
  }

  const handler = (entries) => {
    if (!entries[0].isIntersecting) {
      navigation.classList.add('enabled')
    } else {
      navigation.classList.remove('enabled')
    }
  }

// create the observer
  const observer = new window.IntersectionObserver(handler, options);
// give the observer some dom nodes to keep an eye on
  observer.observe(header);


  for (let button = 0; button < navButtons.length; button++) {
    navButtons[button].addEventListener('click', function () {
      let expanded = this.getAttribute('aria-expanded') === 'true' || false;
      this.setAttribute('aria-expanded', !expanded);
      navigationList.hidden = !navigationList.hidden;
    });
  }

  document.addEventListener('click', function (event) {
    var isClickInside = navButtonScroll.contains(event.target);

    if (!isClickInside) {
      if (navButtonScroll.getAttribute('aria-expanded') == 'true') {
        navButtonScroll.setAttribute('aria-expanded', 'false');
        navigationList.hidden = !navigationList.hidden;
      }
    }
  }, false);

  document.addEventListener('click', function (event) {
    var isClickInside = navButtonNoScroll.contains(event.target);

    if (!isClickInside) {
      if (navButtonNoScroll.getAttribute('aria-expanded') == 'true') {
        navButtonNoScroll.setAttribute('aria-expanded', 'false');
        navigationList.hidden = !navigationList.hidden;
      }
    }
  }, false);

}
